import { createSlice } from '@reduxjs/toolkit';
import initialState from './cbpAuthInitialState';
import {
  _setAuthStartDate,
  _setDayQuantity,
  _setAuthEndDate,
} from './cbpAuthFormActions';

export const cbpAuthSlice = createSlice({
  name: 'cbpAuthForm',
  initialState,
  reducers: {
    cbpAuthForm: (state, action) => action.payload,
    newCbpAuthForm: (state, action) => action.payload,
    setAuthStartDate: _setAuthStartDate,
    setDayQuantity: _setDayQuantity,
    setAuthEndDate: _setAuthEndDate,
  },
});

export const {
  cbpAuthForm,
  newCbpAuthForm,
  setAuthStartDate,
  setDayQuantity,
  setAuthEndDate,
} = cbpAuthSlice.actions;

export default cbpAuthSlice.reducer;
